var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1287 7.42262C18.8541 7.42262 20.5777 7.88137 20.5777 7.88137C25.247 8.95137 28.5336 13.2523 28.5336 18.1082V31.1785L29.4883 32.1376L30.286 32.9388H5.76656L6.56423 32.1376L7.5189 31.1785V18.1082C7.5189 13.2524 10.8055 8.95137 15.4748 7.88137C15.4748 7.88137 17.3228 7.42262 17.9238 7.42262M18.0263 0C16.2234 0 14.8451 1.38454 14.8451 3.19557V4.68673C8.80071 6.07178 4.2414 11.6106 4.2414 18.1082V29.8253L0 34.086V36.2164H36.0525V34.086L31.8111 29.8253V18.1082C31.8111 11.6106 27.2517 6.07178 21.2074 4.68673V3.19557C21.2074 1.38454 19.8291 0 18.0263 0ZM22.2677 38.3468H13.7848C13.7848 40.6903 15.6932 42.6075 18.0263 42.6075C20.3593 42.6075 22.2677 40.6903 22.2677 38.3468Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e9915e0d48b60a3444189acf25db62ce.svg";
export { ForwardRef as ReactComponent };